module.exports = __webpack_public_path__ + "static/media/mini_logo.824cb70e.png";